import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";
import auth from "./modules/auth";
import breadcrumbs from "./modules/breadcrumbs";
import kiosk from "./modules/kiosk";
import oneSignal from "./modules/one-signal";
import toasts from "./modules/toasts";
import toolbarActions from "./modules/toolbar-actions";

Vue.use( Vuex );

export default new Vuex.Store( {
	modules: {
		app,
		auth,
		breadcrumbs,
		kiosk,
		oneSignal,
		toasts,
		toolbarActions
	}
} );
